module.exports = __webpack_public_path__ + "img/registerloradevice.d28de6c6.png";